import firebase from 'firebase/compat'
import { useCollectionData } from 'hooks/firebase'
import { IUser } from '.'

export const useContacts = () => useCollectionData<IUser>(firebase.firestore().collection('users'))
